export default function GallerySlidePage({id, children}) {
  return (
    <div id={id} className="page-wrapper">
      { children }
    </div>
  )
}